import env from "@env";

export const config = (() => {
	return { ...env };
})();
